(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire9a00"];
var parcelRegister = parcelRequire.register;
parcelRegister("k0qQr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cf74e9af1ccd520a$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $9msyL = parcelRequire("9msyL");

var $28FCd = parcelRequire("28FCd");

var $aKUvo = parcelRequire("aKUvo");

var $ahJYx = parcelRequire("ahJYx");

var $17TIY = parcelRequire("17TIY");

var $lBuWd = parcelRequire("lBuWd");

var $epZoF = parcelRequire("epZoF");

var $ahcAq = parcelRequire("ahcAq");

const $cf74e9af1ccd520a$var$_PlayerSeason = ()=>{
    const { id: id, season_id: season_id } = (0, $bTBLz.useParams)();
    const fetchResult = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).ApiRestOtePlayersUrl}/${id}`,
        key: "ote_player"
    });
    const player = fetchResult.result?.read();
    if (!player) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $lBuWd.default), null);
    const team = player.ote_team;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $17TIY.default), {
        team: team
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $aKUvo.default), {
        player: player,
        team: team
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $ahJYx.default), {
        player: player,
        season_id: season_id
    }));
};
const $cf74e9af1ccd520a$var$PlayerSeason = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $9msyL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayerSeason"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $28FCd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($cf74e9af1ccd520a$var$_PlayerSeason, null))));
};
var $cf74e9af1ccd520a$export$2e2bcd8739ae039 = $cf74e9af1ccd520a$var$PlayerSeason;

});
parcelRegister("aKUvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde078bcade4b00c$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $5gQ0v = parcelRequire("5gQ0v");

var $7gWUw = parcelRequire("7gWUw");

var $jGY54 = parcelRequire("jGY54");

var $96bGs = parcelRequire("96bGs");

var $fy0H4 = parcelRequire("fy0H4");

const $bde078bcade4b00c$var$Profile = ({ player: player, team: team })=>{
    const teamColor = {
        color: team?.is_current ? (0, $fy0H4.colorFromInt)(team.secondary_foreground_color) : (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.WHITE
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayerProfile",
        style: {
            backgroundColor: team?.is_current ? (0, $fy0H4.colorFromInt)(team.secondary_color) : (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5gQ0v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        href: `/players/${player.id}`,
        className: "ProfileContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        style: {
            backgroundImage: `linear-gradient(180deg, ${(0, $fy0H4.colorFromInt)(team?.primary_color ?? 0xaaaaaa)} 0%, ${(0, $fy0H4.colorFromInt)(team?.primary_color ?? 0xaaaaaa)} 20% , white)`
        },
        className: [
            "ImageContainer",
            !player.image_path ? "Placeholder" : null
        ].filter(Boolean).join(" ")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        alt: player.full_name,
        src: player.image_path ? `https://images.overtime.tv/${player.image_path}` : (0, $7gWUw.imgOteLogoWhiteSvg)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h1", {
        style: teamColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, player.first_name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, player.family_name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Position"
    }, (0, $jGY54.positions)[player.position])))));
};
var $bde078bcade4b00c$export$2e2bcd8739ae039 = $bde078bcade4b00c$var$Profile;

});

parcelRegister("ahJYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda3d5d50a185e44$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $5wMv4 = parcelRequire("5wMv4");

var $5gQ0v = parcelRequire("5gQ0v");

var $epZoF = parcelRequire("epZoF");

var $enLvs = parcelRequire("enLvs");

var $ahcAq = parcelRequire("ahcAq");

const $fda3d5d50a185e44$var$Season = ({ season_id: season_id, player: player })=>{
    const season = player.ote_seasons_ote_players.find((s)=>s.ote_season_id === season_id)?.ote_season;
    const fetchResult = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).ApiRestOteSeasonsUrl}/${season_id}/ote_games?ote_player_id=${player.id}`,
        key: "ote_games"
    });
    const seasonPlayer = player.ote_seasons_ote_players.find((s)=>s.ote_season_id === season_id);
    const games = (0, $275Aj.sortBy)(fetchResult.result.read().filter((g)=>g.ote_games_ote_players_ote_teams[0]?.minutes > 0), "starts_at");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5gQ0v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayerSeasonSeason"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, season?.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5wMv4.default), {
        rows: games.map((g)=>({
                ...g.ote_games_ote_players_ote_teams[0],
                ote_game: g
            })),
        averageRow: seasonPlayer,
        per40Row: seasonPlayer,
        rowHeader: (r)=>season.should_show_for_teams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
                href: `/games/${r.ote_game_id}`,
                className: "Game"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                title: r.ote_game.competition_name
            }, r.ote_game.ote_games_ote_teams.find((t)=>!t.is_home_team).ote_team.name, " @\n", r.ote_game.ote_games_ote_teams.find((t)=>t.is_home_team).ote_team.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                className: "Date"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $enLvs.default), {
                timestamp: r.ote_game.starts_at
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                className: "Game"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                title: r.ote_game.competition_name
            }, r.ote_game.ote_games_ote_teams.find((t)=>!t.is_home_team).ote_team.name, " @\n", r.ote_game.ote_games_ote_teams.find((t)=>t.is_home_team).ote_team.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                className: "Date"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $enLvs.default), {
                timestamp: r.ote_game.starts_at
            })))
    })));
};
var $fda3d5d50a185e44$export$2e2bcd8739ae039 = $fda3d5d50a185e44$var$Season;

});


})();
//# sourceMappingURL=PlayerSeason.4a5514f5.js.map
